import * as types from "./SelectedMembersForConfirmationType";

export default function selectedMembersForConfirmationType(state = { data: [] }, action) {
    switch (action.type) {
        case types.CLEAR: {
            const newData = { [action.model.name]: {} };
            return { ...state, ...newData };
        }
        case types.ADD_MEMBER: {
            const data = [...state.data, action.member];
            return {
                ...state,
                data: data,
            };
        }
        case types.REMOVE_MEMBER: {
            const indexToRemove = state.data.findIndex(
                (member) =>
                    member.memberId == action.member.memberId &&
                    member.startDate == action.member.startDate &&
                    member.endDate == action.member.endDate
            );
            let newArr = [...state.data]; // We don't want to directly modify state with splice.

            if (indexToRemove != -1) {
                newArr.splice(indexToRemove, 1);
            }

            return {
                ...state,
                data: newArr,
            };
        }

        case types.CLEAR_MEMBERS: {
            return { ...state, data: [] };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/SelectedMembersForConfirmationReducer.js